import React from 'react';
import "../styles/About.css"
import { motion } from "framer-motion";
import ProfileImg from '../images/profile.webp'

const About = () => {  
  
  const horizontal ={
    x:0, 
    opacity: 1, 
    transition:{type: 'spring', duration: 2,bounce: 0.3}
  }

  return (
      <>
          <div  className="about" id='about'>
              <div className="container">
                  <motion.div initial={{x: '-100%', opacity: 0}} whileInView={horizontal} viewport={{ once: true }} className="heading">
                    <p className="heading-sub-text">Who I am</p>
                    <p className='heading-text'>About Me</p>
                  </motion.div>
                  <div className="split-about">
                    <motion.div initial={{x: '-100%', opacity: 0}} whileInView={horizontal} className="about-content">
                        <p>Hi, I am an ambitious PhD student from UMass Boston, majoring in Computer Science, and focusing my research on mitigating bias and enhance fairness in Recommender Systems. I also bring with me a wealth of knowledge from over four years of professional experience. I am highly motivated to expand my skillset and expertise, with a strong desire to make a significant and valuable contribution.</p>
                        <br />
                        <p> From my past work experiences, I've become skilled in various tools/technologies. It also gave me the opportunity to handle responsibilities across different and multiple stages.</p>
                    </motion.div>
                    <motion.div initial={{x: '50', opacity: 0}} whileInView={horizontal}  className='about-img'>
                        <img src={ProfileImg} alt="Profile" />
                    </motion.div>
                  </div>
              </div>
          </div>
      </>
  )
};

export default About;
